import { mapState, mapActions } from "vuex";

export default {

  computed: {
    ...mapState({
      client_id: state => state.booleanSearch.client_id,
      project_id: state => state.booleanSearch.project_id,
      searches: state => state.booleanSearch.searches,
      group_library: state => state.booleanSearch.group_library,
      tag_library: state => state.booleanSearch.tag_library,
    }),
    searchesData() { return this.searches.data },
    searchesPagination() { return this.searches.pagination },
    searchesFilters() { return this.searches.filters },
    searchesAreBusy() { return this.searches.isBusy },
    searchesAreInitiated() { return this.searches.isInitiated },
    searchesDeletedQuery() { return this.searches.deletedQuery },
    searchesCanLoadMore() { return this.searchesAreInitiated && !this.searchesAreBusy && this.searchesPagination.page && this.searchesPagination.page < this.searchesPagination.total_pages },
    searchesAllLoaded() { return this.searchesAreInitiated && this.searchesPagination.page >= this.searchesPagination.total_pages },
    searchesNoData() { return this.searchesAreInitiated && !this.searchesData.length },

    groupsData() { return this.group_library.data },
    groupsPagination() { return this.group_library.pagination },
    groupsFilters() { return this.group_library.filters },
    groupsAreBusy() { return this.group_library.isBusy },
    groupsAreInitiated() { return this.group_library.isInitiated },
    groupsDeletedQuery() { return this.group_library.deletedQuery },
    groupsCanLoadMore() { return this.groupsAreInitiated && !this.groupsAreBusy && this.groupsPagination.page && this.groupsPagination.page < this.groupsPagination.total_pages },
    groupsAllLoaded() { return this.groupsAreInitiated && this.groupsPagination.page >= this.groupsPagination.total_pages },
    groupsNoData() { return this.groupsAreInitiated && !this.groupsData.length },

    tagsSearchesData() { return this.tag_library.data },
    tagsSearchesPagination() { return this.tag_library.pagination },
    tagsSearchesFilters() { return this.tag_library.filters },
    tagsSearchesAreBusy() { return this.tag_library.isBusy },
    tagsSearchesAreInitiated() { return this.tag_library.isInitiated },
    tagsSearchesDeletedQuery() { return this.tag_library.deletedQuery },
    tagsSearchesCanLoadMore() { return this.tagsSearchesAreInitiated && !this.tagsSearchesAreBusy && this.tagsSearchesPagination.page && this.tagsSearchesPagination.page < this.tagsSearchesPagination.total_pages },
    tagsSearchesAllLoaded() { return this.tagsSearchesAreInitiated && this.tagsSearchesPagination.page >= this.tagsSearchesPagination.total_pages },
    tagsSearchesNoData() { return this.tagsSearchesAreInitiated && !this.tagsSearchesData.length },

    deletedQuery() {
      if(this.resourceName === 'group_library') return this.groupsDeletedQuery
      if(this.resourceName === 'tag_library') return this.tagsSearchesDeletedQuery
      return this.searchesDeletedQuery
    }
  },

  methods: {
    ...mapActions({
      getPaginatedResource: 'booleanSearch/getPaginatedResource',
    }),
  },
}